var ctrl = function($scope, $timeout, $state, $stateParams, $http) {
  $scope.widget = {descriptionField: $scope.descriptionField,
    inputModel: [],
    addToListFromAutocompleteOnly: $scope.addToListFromAutocompleteOnly};

  $scope.prepare = function() {
    $scope.extraParams = {};
    $scope.useSpecifiedIdsForListLookup = false;
    switch($scope.objectType) {
      case 'product_line':
        $scope.widget.id = 'product_lines_autocomplete';
        $scope.widget.placeholder = 'Search Product Lines...';
        $scope.widget.path = 'product_lines';
        $scope.widget.descriptionField = $scope.descriptionField || 'manufacturer.name';
        break;
      case 'product_packaging_description':
        $scope.widget.id = 'product_packaging_description_autocomplete';
        $scope.widget.placeholder = 'Search Packaging Descriptions...';
        $scope.widget.path = 'product_packaging_description';
        break;
      case 'retailer':
        $scope.widget.id = 'retailers_autocomplete';
        $scope.widget.placeholder = 'Search Retailers...';
        $scope.widget.path = 'retailers';
        $scope.extraParams.listType = 'retailers';
        $scope.useSpecifiedIdsForListLookup = true;
        break;
      case 'manufacturer':
        $scope.widget.id = 'manufacturers_autocomplete';
        $scope.widget.placeholder = 'Search Manufacturers...';
        $scope.widget.path = 'manufacturers';
        break;
      case 'brand_family':
        $scope.widget.id = 'brand_families_autocomplete';
        $scope.widget.placeholder = 'Search Brand Families...';
        $scope.widget.path = 'brand_families';
        break;
      case 'distributor':
        $scope.widget.id = 'distributors_autocomplete';
        $scope.widget.placeholder = 'Search Distributors...';
        $scope.widget.path = 'distributors';
        $scope.extraParams.listType = 'distributors';
        break;
      case 'distribution_area':
        $scope.widget.id = 'distribution_areas_autocomplete';
        $scope.widget.placeholder = 'Search Distribution Areas...';
        $scope.widget.path = 'distribution_areas';
        break;
      case 'category':
        $scope.widget.id = 'categories_autocomplete';
        $scope.widget.placeholder = 'Search Categories';
        $scope.widget.path = 'categories';
        break;
      case 'subcategory':
        $scope.widget.id = 'subcategories_autocomplete';
        $scope.widget.placeholder = 'Search Subcategories...';
        $scope.widget.path = 'subcategories';
        break;
      case 'collection':
        $scope.widget.id = 'collections_autocomplete';
        $scope.widget.placeholder = 'Search Collections By Name...';
        $scope.widget.path = 'collections';
        break;
      case 'segment':
        $scope.widget.id = 'segments_autocomplete';
        $scope.widget.placeholder = 'Search Segments...';
        $scope.widget.path = 'collection_segments';
        $scope.widget.descriptionField = $scope.descriptionField || 'zip';
        break;
      case 'user':
        $scope.widget.id = 'users_autocomplete';
        $scope.widget.placeholder = 'Search Users by Name or Email...';
        $scope.widget.path = 'users';
        $scope.widget.descriptionField = $scope.descriptionField || 'email';
        $scope.titleField = 'first_name,last_name';
        if ($scope.listMode) { $scope.titleField = 'email'; }
        $scope.nameField = 'email';
        $scope.useSpecifiedIdsForListLookup = true;
        break;
      case 'sales_rep':
        $scope.widget.id = 'sales_reps_autocomplete';
        $scope.widget.placeholder = 'Search Sales Reps...';
        $scope.widget.path = 'sales_reps';
        $scope.widget.descriptionField = $scope.descriptionField || 'contact_email'
        break;
      case 'warehouse':
        $scope.widget.id = 'warehouses_autocomplete';
        $scope.widget.placeholder = 'Search Warehouses...';
        $scope.widget.path = 'warehouses';
        break;
      case 'wine_appellation':
        $scope.widget.id = 'wine_appellation_autocomplete';
        $scope.widget.placeholder = 'Search Wine Appellations...';
        $scope.widget.path = 'wine_appellations';
        break;
      case 'wine_region':
        $scope.widget.id = 'wine_region_autocomplete';
        $scope.widget.placeholder = 'Search Wine Regions...';
        $scope.widget.path = 'wine_regions';
        break;
      case 'wine_varietal':
        $scope.widget.id = 'wine_varietal_autocomplete';
        $scope.widget.placeholder = 'Search Wine Varietals...';
        $scope.widget.path = 'wine_varietals';
        break;
      case 'wine_country':
        $scope.widget.id = 'wine_country_autocomplete';
        $scope.widget.placeholder = 'Search Wine Countries...';
        $scope.widget.path = 'wine_countries';
        break;
      case 'city':
        $scope.widget.id = 'cities_autocomplete';
        $scope.widget.placeholder = 'Add a city...';
        break;
      case 'zipcode':
        $scope.widget.id = 'zipcodes_autocomplete';
        $scope.widget.placeholder = 'Add a zipcode...';
        break;
      case 'market':
        $scope.widget.id = 'markets_autocomplete';
        $scope.widget.placeholder = 'Add a market...';
        $scope.widget.path = 'markets';
        break;
      case 'county':
        $scope.widget.id = 'counties_autocomplete';
        $scope.widget.placeholder = 'Add a county...';
        $scope.widget.path = 'counties';
        $scope.nameField = 'county_name';
        break;
      case 'retailer_organization_mandate':
        $scope.widget.id = 'retailer_organization_mandates_autocomplete';
        $scope.widget.placeholder = 'Search Retailer Organization Mandates...';
        $scope.widget.path = 'retailer_organization_mandates';
        break;
      case 'retailer_organization':
        $scope.widget.id = 'retailer_organizations_autocomplete';
        $scope.widget.placeholder = 'Search Retailer Organizations...';
        $scope.widget.path = 'retailer_organizations';
        break;
      case 'tags':
        $scope.widget.id = 'tags_autocomplete';
        $scope.widget.placeholder = 'Search Tags...';
        $scope.widget.path = 'tags';
        $scope.extraApiParams = {tag_type: 'product_line'};
        break;
    }
    $scope.widget.titleField = $scope.titleField || 'name';
    $scope.widget.dropdownTitleField = $scope.dropdownTitleField || $scope.widget.titleField;
    $scope.widget.keyField = $scope.keyField;
    $scope.nameField = $scope.nameField || 'name';
    $scope.searchURL = $scope.searchUrlInput || ('/api/admin/' + $scope.widget.path);
    $scope.keyName = $scope.objectType + '_id';
    $scope.nameName = $scope.objectType + '_name';
    $scope.widget.initialValue = $stateParams[$scope.nameName] || $scope.initialValue;
    if ($scope.selectModel && !$scope.initialValue && !$scope.listMode) {
      $scope.setInitialValue();
    }
  }

  $scope.prepareListMode = function() {
    if (!$scope.selectModel) { return; }
    // in list mode selectModel is an angular model with an ID array for the given object
    if ($scope.skipListAutocomplete) {
      $scope.widget.inputModel = angular.copy($scope.selectModel);
    } else {
      if ($scope.selectModel.length) {
        if ($scope.useSpecifiedIdsForListLookup) {
          if (!$scope.apiParams) { $scope.apiParams = {}; }
          $scope.apiParams.specified_ids = $scope.selectModel;
        }
        $scope.searchAPI(null, null).then(function(res) {
          $scope.widget.inputModel = _.compact(_.map($scope.selectModel, function(x) { return _.find(res.data, {id: x})}));
          if ($scope.useSpecifiedIdsForListLookup) {
            delete $scope.apiParams.specified_ids;
          }
        });
      }
    }
  }

  $scope.searchAPI = function(input, timeoutPromise) {
    var params = {
      search: input,
      show_all: true,
      all_retailers: true
    };
    if ($scope.listMode && input == null) {
      delete params.search
    }
    if ($scope.apiParams) {
      params = _.merge(params, $scope.apiParams);
    }
    if ($scope.extraApiParams) {
      params = _.merge(params, $scope.extraApiParams);
    }

    return $http({
      method: 'GET',
      url: $scope.searchURL,
      params: params
    });
  };

  var refreshState = function(changes) {
    var newParams = angular.copy($stateParams);
    _.extend(newParams, changes);
    $state.go('.', newParams);
  };

  $scope.setInitialValue = function() {
    return $http({
      method: 'GET',
      url: $scope.searchURL + '/' + $scope.selectModel
    }).then(function(res) {
      if (res && res.data) {
        $scope.widget.initialValue = res.data[$scope.nameField];
      }
    });
  };

  const refreshStateOnDelay = function(changes) {
    $scope.toCancel = $timeout(function() {
      refreshState(changes)
    }, 500);
  }

  $scope.selectObj = function(selected) {
    var changes = $scope.extraParams;
    if (selected) {
      changes[$scope.keyName] = selected.originalObject.id;
      changes[$scope.nameName] = selected.originalObject[$scope.nameField];
      if ($scope.selectCallback) {
        return $scope.selectCallback({selected: selected});
      } else {
        $scope.selectModel = selected.originalObject.id;
        if (!$scope.skipRefreshStateOnSelectModel) {
          refreshState(_.merge(changes, {page: 1}));
        }
      }
    } else {
      changes[$scope.keyName] = null;
      changes[$scope.nameName] = null;
      if ($scope.selectCallback) {
        return $scope.selectCallback({selected: selected});
      } else {
        $scope.selectModel = null;
        if (!$scope.skipRefreshStateOnSelectModel) {
          refreshStateOnDelay(changes);
        }
      }
    }
  };

  $scope.inputChanged = function(name) {
    if ($scope.toCancel) { $timeout.cancel($scope.toCancel) }
    if ($scope.inputChangedCallback) {
      return $scope.inputChangedCallback({name: name});
    }
  };

  if ($scope.style == 'bootstrap') {
    $scope.widget.classes = 'form-group';
    $scope.widget.inputClasses = 'form-control';
  } else {
    if ($scope.size == 'small') {
      $scope.widget.classes = 'autocomplete-wrapper full-width';
      $scope.widget.inputClasses = 'input input--small';
    } else {
      $scope.widget.classes = "autocomplete-wrapper input-wrapper full-width";
      $scope.widget.inputClasses = "input";
    }
  }

  $scope.listInputAdded = function(selected) {
    if ($scope.skipListAutocomplete) {
      $scope.selectModel = _.concat($scope.selectModel, selected.name);
    } else {
      if ($scope.addFullObjectToList) {
        $scope.selectModel = _.concat($scope.selectModel, selected);
      } else {
        $scope.selectModel = _.concat($scope.selectModel, selected.id);
      }
    }
  };

  $scope.listInputRemoved = function(selected) {
    if ($scope.skipListAutocomplete) {
      $scope.selectModel = _.pull($scope.selectModel, selected.name);
    } else {
      $scope.selectModel = _.pull($scope.selectModel, selected.id);
    }
  };

  $scope.prepare();
  if ($scope.listMode) { $scope.prepareListMode(); }
};

ctrl.$inject = ["$scope", '$timeout', '$state', '$stateParams' ,'$http'];

tiz.controller("autocompleteCtrl", ctrl);
tiz.directive("proviAutocomplete", function() {
  return {
    scope: {
      objectType: '@',
      selectCallback: '&?',
      addToListCallback: '&?',
      removeFromListCallback: '&?',
      inputChangedCallback: '&?',
      initialValue: '=?',
      descriptionField: '@?',
      keyField: '@?',
      dropdownTitleField: '@?',
      apiParams: '=?',
      size: '@?',
      style: '@?',
      titleField: '@?',
      searchUrlInput: '@?',
      listMode: '@?',
      selectModel: '=?',
      addToListFromAutocompleteOnly: '=?',
      addFullObjectToList: '=?',
      skipListAutocomplete: '=?',
      skipRefreshStateOnSelectModel: '=?',
      disabled: '=?',
    },
    templateUrl: require('../templates/autocomplete/autocomplete.html'),
    controller: "autocompleteCtrl"
  };
});
